export default "__VITE_ASSET__Dgn3Y0OE__"